import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showServerErrorMessage,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {OtherPaymentService} from "../../serverService/otherPayment/OtherPaymentService";
import {OtherPaymentsService} from "../../serverService/otherPayments/OtherPaymentsService";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {convertCurrencyFormat} from "../../util/numberConvertor";
import AddNewOtherPayment from "../../serverService/otherPayment/AddNewOtherPayment";
import {useNavigate} from "react-router-dom";

export default function OtherPayments() {

    const [otherPaymentsList, setOtherPaymentsList] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState("");
    const size = 20;

    const {fundID} = useAuthState()

    const service = new OtherPaymentsService()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getOtherPaymentsListFromServer()
        }
    }, [fundID]);


    function preparationTable(id, number, title, amountPerUnit, enabled) {
        return {
            id: id,
            number: number,
            title: title,
            paid: convertCurrencyFormat(amountPerUnit),
            state: enabled ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }


    function getOtherPaymentsListFromServer() {
        setTableLoading(true)
        service.getOtherPaymentsList(
            page,
            size,
            fundID
        ).then(
            response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setOtherPaymentsList([])
                response.data.map((item, index) => {
                    setOtherPaymentsList(prevState => [
                        ...prevState,
                        preparationTable(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.amountPerUnit,
                            item.enabled
                        )
                    ])
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    const handleChangePage = (newPage) => {
        setPage(newPage)
        getOtherPaymentsListFromServer()
    }
    const [openDialog, setOpenDialog] = useState(false);

    function handleOpenDialog() {
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
    }

    function addNewItemToTable(item) {
        const newItem = addNewRowToTable(
            preparationTable(
                item.id,
                (page * size) + 1,
                item.title,
                item.amountPerUnit,
                item.enabled
            ),
            otherPaymentsList
        )
        setOtherPaymentsList(newItem)
        handleCloseDialog()
    }

    const navigate = useNavigate()

    function showOtherPaymentDetails(id) {
        let title = ""
        otherPaymentsList.map((item) => {
            if (item.id === id) {
                title = item.title
            }
        })
        navigate(RouteHelper.OtherPaymentsDetails.globalUrl.replace(":id", id),
            {state: {title: title}, replace: false}
        )
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.OtherPayments.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن سایر پرداخت جدید"}
                dialogSize={DialogSize.LARGE}
            >
                <AddNewOtherPayment addNewItemToTable={addNewItemToTable}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.OtherPayments.name,
                            ""
                        ),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"سایر پرداخت ها"}
                                amount={numberOfItems}
                                hasCreateNewItem={true}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={otherPaymentsHeader}
                                data={otherPaymentsList}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePage}
                                rowClicked={showOtherPaymentDetails}
                            />

                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


const otherPaymentsHeader = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'paid',
        label: 'مبلغ واحد (ریال)'
    },
    {
        id: 'state',
        label: 'وضعیت'
    },
]